/**
 * Cheque Bounce Transactions Table Component
 * Displays cheque payment details with grouping and totals
 */
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import LoadingComponent from '../../loadingComponent';

export class ChequeBounceTransactionsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
            isLoading: false
        };

        // Bind methods
        this.processTransactionsData = this.processTransactionsData.bind(this);
    }

    componentDidMount() {
        console.log('ChequeBounceTransactionsTable component mounted');
        const { transactionsData, transactionsLoading } = this.props;

        if (transactionsData) {
            this.processTransactionsData(transactionsData);
        } else if (transactionsLoading === false) {
            this.setState({ isLoading: false, transactions: [] });
        }
    }

    componentDidUpdate(prevProps) {
        const { transactionsData, transactionsLoading } = this.props;

        if (transactionsData !== prevProps.transactionsData && transactionsData) {
            this.processTransactionsData(transactionsData);
        } else if (transactionsLoading === false && prevProps.transactionsLoading === true && !transactionsData) {
            this.setState({ isLoading: false, transactions: [] });
        }
    }

    processTransactionsData(data) {
        console.log('ChequeBounceTransactionsTable - Processing transactions data:', data);

        const bouncedCheques = data?.bouncedCheques || [];

        if (bouncedCheques && bouncedCheques.length > 0) {
            console.log('Bounced cheques found:', bouncedCheques.length);
            
            this.setState({
                transactions: bouncedCheques,
                isLoading: false
            });
        } else {
            console.log('ChequeBounceTransactionsTable - No bounced cheques in data');
            this.setState({
                transactions: [],
                isLoading: false
            });
        }
    }

    formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Column body templates
    snoBodyTemplate = (rowData, { rowIndex }) => {
        return <span style={{ display: 'block', textAlign: 'center' }}>{rowIndex + 1}</span>;
    };

    chequeNoBodyTemplate = (rowData) => {
        return <span>{rowData.chequeNo || 'N/A'}</span>;
    };

    chequeDateBodyTemplate = (rowData) => {
        return <span>{this.formatDate(rowData.chequeDate)}</span>;
    };

    bankNameBodyTemplate = (rowData) => {
        return <span>{rowData.bankName || 'N/A'}</span>;
    };

    receiptDateBodyTemplate = (rowData) => {
        return <span>{this.formatDate(rowData.depositDate)}</span>;
    };

    reconciliationStatusBodyTemplate = (rowData) => {
        const status = rowData.chequeDDStatus || 'Pending';
        const statusClass = status === 'Reconciled' || status === 'cleared' ? 'status-reconciled' : 'status-pending';
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span className={statusClass}>{status}</span>
                {/* <i 
                    className="pi pi-info-circle reconciliation-info-icon" 
                    data-pr-tooltip="Reconciliation status information"
                    data-pr-position="top"
                    style={{ color: '#076EFF', cursor: 'pointer' }}
                /> */}
            </div>
        );
    };

    feeTypeBodyTemplate = (rowData) => {
        return <span>{rowData.bankBranchName || 'N/A'}</span>;
    };

    paidAmountBodyTemplate = (rowData) => {
        const amount = parseFloat(rowData.amount) || 0;
        return <span style={{ textAlign: 'right', display: 'block' }}>
            ₹{amount.toFixed(2)}
        </span>;
    };

    totalBodyTemplate = (rowData) => {
        const amount = parseFloat(rowData.amount) || 0;
        return <span style={{ textAlign: 'right', display: 'block' }}>
            ₹{amount.toFixed(2)}
        </span>;
    };

    render() {
        const { transactions, isLoading } = this.state;

        return (
            <div className="cheque-bounce-transactions-table-container">
                {isLoading && <LoadingComponent />}
                
                <Tooltip target=".reconciliation-info-icon" />

                {!isLoading && (
                    <div className="transactions-table-wrapper">
                        <div className="data-table-scroll-container">
                            <DataTable
                                value={transactions}
                                scrollable
                                scrollHeight="flex"
                                className="transactions-table"
                                showGridlines
                                emptyMessage="No Records to Display !!!..."
                            >
                                <Column
                                    header="S.No"
                                    body={this.snoBodyTemplate}
                                    headerClassName="sno-header"
                                    bodyClassName="sno-cell"
                                    style={{ width: '70px', minWidth: '70px', textAlign: 'center' }}
                                />
                                <Column
                                    header="Cheque No"
                                    body={this.chequeNoBodyTemplate}
                                    headerClassName="cheque-no-header"
                                    bodyClassName="cheque-no-cell"
                                    style={{ width: '180px', minWidth: '180px' }}
                                />
                                <Column
                                    header="Cheque Date"
                                    body={this.chequeDateBodyTemplate}
                                    headerClassName="cheque-date-header"
                                    bodyClassName="cheque-date-cell"
                                    style={{ width: '130px', minWidth: '130px' }}
                                />
                                <Column
                                    header="Bank Name"
                                    body={this.bankNameBodyTemplate}
                                    headerClassName="bank-name-header"
                                    bodyClassName="bank-name-cell"
                                    style={{ width: '180px', minWidth: '180px' }}
                                />
                                 <Column
                                    header="Bank Branch"
                                    body={this.feeTypeBodyTemplate}
                                    headerClassName="fee-type-header"
                                    bodyClassName="fee-type-cell"
                                    style={{ width: '180px', minWidth: '180px' }}
                                />
                                <Column
                                    header="Deposit Date"
                                    body={this.receiptDateBodyTemplate}
                                    headerClassName="receipt-date-header"
                                    bodyClassName="receipt-date-cell"
                                    style={{ width: '130px', minWidth: '130px' }}
                                />
                                <Column
                                    header="Reconciliation Status"
                                    body={this.reconciliationStatusBodyTemplate}
                                    headerClassName="reconciliation-status-header"
                                    bodyClassName="reconciliation-status-cell"
                                    style={{ width: '220px', minWidth: '220px' }}
                                />
                               
                                <Column
                                    header="Amount"
                                    body={this.paidAmountBodyTemplate}
                                    headerClassName="paid-amount-header"
                                    bodyClassName="paid-amount-cell"
                                    style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                                />
                                <Column
                                    header="Total"
                                    body={this.totalBodyTemplate}
                                    headerClassName="total-header"
                                    bodyClassName="total-cell"
                                    style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                                />
                            </DataTable>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
